module.exports = __webpack_public_path__ + "img/icono-mensaje-settings.daca1db4.svg";